import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  CircularProgress,
} from '@mui/material';
import JsonEditor from './JsonEditor.js';
import PdfPreview from './PdfPreview.js';
import "./ExtractedData.css";

const ExtractedData = ({
  file,
  pdfUrl,
  loading,
  error,
  extractedData,
  handleJsonChange,
  userRole,
  isSaved,
  transactionId,
  documentId,
  isDocumentManager = false,
  onEditChange,
}) => {
  const [currentTheme, setCurrentTheme] = useState('dark');

  // Detect theme from the document body or root element
  useEffect(() => {
    const detectTheme = () => {
      const body = document.body;
      const appContainer = document.querySelector('.app-container');
      const rootElement = appContainer || body;
      
      if (rootElement.classList.contains('light-theme')) {
        setCurrentTheme('light');
      } else {
        setCurrentTheme('dark');
      }
    };

    // Initial detection
    detectTheme();

    // Watch for theme changes using MutationObserver
    const observer = new MutationObserver(detectTheme);
    
    const body = document.body;
    const appContainer = document.querySelector('.app-container');
    const targetElement = appContainer || body;
    
    observer.observe(targetElement, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return () => observer.disconnect();
  }, []);

  if (!file || isSaved) {
    return null;
  }

  console.log('ExtractedData props:', { transactionId, documentId });

  // Determine if light theme
  const isLightTheme = currentTheme === 'light';

  return (
    <Box className="preview-data-section">
      <PdfPreview pdfUrl={pdfUrl} />
      <Box className="extracted-data">
        {/* Removed the data-container Box wrapper */}
        {loading ? (
          <Box 
            className="loading-container"
            sx={{
              background: isLightTheme 
                ? 'rgba(255, 255, 255, 0.95) !important' 
                : 'var(--card-background) !important',
              backdropFilter: isLightTheme ? 'blur(5px)' : 'var(--backdrop-blur)',
            }}
          >
            <CircularProgress className="loading-spinner" />
          </Box>
        ) : error ? (
          <Typography 
            className="error-text"
            sx={{
              background: isLightTheme 
                ? 'rgba(239, 68, 68, 0.05) !important' 
                : 'var(--card-background) !important',
            }}
          >
            {error}
          </Typography>
        ) : extractedData ? (
          <JsonEditor
            jsonData={extractedData}
            onChange={handleJsonChange}
            isNew={false}
            isAdmin={userRole === 'admin'}
            transactionId={transactionId}
            documentId={documentId}
            fromCustomerProfiling={false}
            onEditChange={onEditChange}
          />
        ) : (
          <Typography className="placeholder-text">
            Upload a PDF to view extracted data
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default ExtractedData;